// extracted by mini-css-extract-plugin
export default {"resume_section":"Resume_resume_section__lly-R","container":"Resume_container__j0GN-","heading":"Resume_heading__iXRFs","title":"Resume_title__U2pu4"};